import { useCallback } from 'react';
import Text from '@ingka/text';
import SSRIcon from '@ingka/ssr-icon';
import documentIcon from '@ingka/ssr-icon/paths/document';
import styles from './FileDownloadButton.module.scss';

export type FileDownloadButtonProps = {
  label: string;
  /**
   * Return filename and dataUrl to make this component handle the download,
   * or return void if handled in some other way
   */
  onDownload: () => { filename: string; dataUrl: string } | void;
};

export const FileDownloadButton: React.FC<FileDownloadButtonProps> = ({ label, onDownload }) => {
  const handleOnClick = useCallback(() => {
    const data = onDownload();
    if (data) {
      const { filename, dataUrl } = data;
      const link = document.createElement('a');
      link.setAttribute('href', encodeURI(dataUrl));
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    }
  }, [onDownload]);

  return (
    <div className={styles['container']} onClick={handleOnClick}>
      <SSRIcon paths={documentIcon} />
      <Text className={styles['text']}>{label}</Text>
    </div>
  );
};
